import React, {
  FC,
  ReactEventHandler,
  useEffect,
  useRef,
  useState,
} from "react";
import { ReactComponent as Divider } from "../assets/svg/divider.svg";
import { ReactComponent as Book } from "../assets/svg/book.svg";
import { ReactComponent as Chart } from "../assets/svg/performance.svg";
import { ReactComponent as Coins } from "../assets/svg/coins.svg";
import { ReactComponent as Crystal } from "../assets/svg/crystal-ball.svg";
import { useNavigate } from "react-router";
import { useAppSelector } from "../store/hooks";
import { selectEVMAccount, selectSolAccount } from "../store/user/userSlice";

const buttonStyles = "rounded-lg bg-white text-black pl-3 pr-3 ml-2";
const divGroupStyles =
  "flex flex-row w-full items-center h-[3rem] hover:text-green-700";

const Drawer: FC = () => {
  const navigate = useNavigate();
  const ref = useRef<HTMLDivElement>(null);
  const hamburger = document.getElementById("hamburger");
  const [click, setClick] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const evmAddress = useAppSelector(selectEVMAccount);
  const solAddress = useAppSelector(selectSolAccount);

  const onClickOutside = () => {
    const drawer = ref.current;
    if (drawer !== null) {
      drawer.classList.remove("drawerOut");
      drawer.classList.add("drawerIn");
      setTimeout(() => {
        drawer.classList.add("hidden");
      }, 250);
    }
  };

  const concatAddr = (addr: string) => {
    const strArr = addr.split("");
    const first = strArr.splice(0, 4);
    const last = strArr.splice(strArr.length - 5, 4);
    const returnedStr = first.join("") + "..." + last.join("");
    return returnedStr;
  };

  const handleConnectClick = () => {
    setShowModal(!showModal);
  };

  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      event.preventDefault();
      setClick(!click);
      const el = event.target as Element;
      //counts as an outside click if the element clicked is not inside the drawer and it's not the hamburger menu button
      if (
        ref.current &&
        !ref.current.contains(el) &&
        el !== hamburger &&
        hamburger &&
        !hamburger.contains(el)
      ) {
        onClickOutside && onClickOutside();
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [onClickOutside]);

  return (
    <div
      ref={ref}
      id="drawer"
      className="hidden w-[300px] h-full bg-black p-3 lg:show-on-mobile absolute right-0 z-5"
    >
      <div className="w-full h-full flex flex-col items-center p-3">
        <div className="text-white pt-10 pb-10">
          <div>
        <button onClick={handleConnectClick} className={buttonStyles}>
            Select Wallet
          </button>
          {evmAddress !== "" ? (
            <p className="text-white mr-3">EVM: {concatAddr(evmAddress)}</p>
          ) : (
            ""
          )}
          {solAddress !== "" ? (
            <p className="text-white mr-3">SOL: {concatAddr(solAddress)}</p>
          ) : (
            ""
          )}
        </div>
        </div>
        <span />
        <Divider className="mt-3 mb-3" />
        <div className="flex flex-col items-start text-white">
          <p className="text-neutral-400 pt-3 pb-3">Dashboard</p>
          <div
            onClick={() => navigate("/")}
            className={divGroupStyles + " fill-white hover:fill-green-700"}
          >
            <Book className=" h-6 w-6" />

            <button className={buttonStyles}>Portfolio</button>
          </div>
          <div
            onClick={() => navigate("/performance")}
            className={divGroupStyles + " stroke-white hover:stroke-green-700"}
          >
            <Chart className="h-6 w-6" />
            <button className={buttonStyles}>Performance</button>
          </div>

          <p className="text-neutral-400 pt-3 pb-3">Invest</p>
          <div
            onClick={() => navigate("/find_rates")}
            className={divGroupStyles + " hover:fill-green-900 fill-white"}
          >
            <Coins className="h-6 w-6" />
            <button className={buttonStyles}>Find Rates</button>
          </div>
          <div
            onClick={() => navigate("/prospect")}
            className={divGroupStyles + " hover:fill-green-900 fill-white"}
          >
            <Crystal className=" h-6 w-6" />
            <button className={buttonStyles}>Prospect</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Drawer;
